import { render } from "./WeddingKioskFormType2.vue?vue&type=template&id=25580e8a&lang=true"
import script from "./WeddingKioskFormType2.vue?vue&type=script&lang=js"
export * from "./WeddingKioskFormType2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__